import type { UseFormMethods } from 'react-hook-form'

import { DrawerFooter, HStack, useDisclosure } from '@chakra-ui/react'

import { Button } from '@/components/ui'
import { mixpanel } from '@/utils/analytics'

import { IncidentFiltersFormInputsI } from '../types/form'
import { SavedFilterI } from '../types/generic'
import { DeactivateFilterConfirmationModal } from './DeactivateFilterConfirmationModal'

interface IncidentsFilterDrawerFooterIProps {
  onApplyFilters: () => void
  activeFilter: SavedFilterI
  setValue: UseFormMethods<IncidentFiltersFormInputsI>['setValue']
}

export const IncidentsFilterDrawerFooter = ({
  onApplyFilters,
  activeFilter,
  setValue,
}: IncidentsFilterDrawerFooterIProps) => {
  const {
    isOpen: isModalOpen,
    onClose: onModalClose,
    onOpen: onModalOpen,
  } = useDisclosure()

  const onClearFilters = () => {
    setValue('facilityName', null)
    setValue('floorName', null)
    setValue('deviceName', null)
    setValue('createdAt', null)
    setValue('incidentStatus', null)
    setValue('sourceType', null)
    setValue('incidentType', null)
    setValue('priority', null)
    setValue('mutedStatus', null)
    setValue('clips', null)
    setValue('aiOperatorState', null)

    mixpanel.track('Button Press: Incidents Drawer - Clear Filters')
  }

  return (
    <DrawerFooter borderColor='#D5DCE4' borderTopWidth='1px'>
      <HStack spacing='5' width='full'>
        <Button
          data-testid='incidentsPage_filterDrawer_clearAllButton'
          isFullWidth
          onClick={onClearFilters}
          variant='secondary'
        >
          Clear All
        </Button>

        <Button
          data-testid='incidentsPage_filterDrawer_applyButton'
          isFullWidth
          onClick={activeFilter ? onModalOpen : onApplyFilters}
        >
          Apply Filters
        </Button>
      </HStack>
      {isModalOpen && (
        <DeactivateFilterConfirmationModal
          activeFilter={activeFilter}
          isOpen={isModalOpen}
          onApplyFilters={onApplyFilters}
          onClose={onModalClose}
        />
      )}
    </DrawerFooter>
  )
}
